// extracted by mini-css-extract-plugin
export default {"root_scroller":"sZ","flex_container":"tZ","container":"uZ","scroller":"vZ","indicator":"wZ","scrollButtons":"xZ","selected":"yZ","root_tab":"zZ","root_tab_scrollable":"AZ","root_scroller_mob":"BZ","scroller_mob":"CZ","indicator_mob":"EZ","selected_mob":"FZ","root_tab_mob":"GZ","root_tab_mob_scrollable":"HZ"};
    if(module.hot) {
      // 1715276859774
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  